var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isStopwatchLoading)?_vm._t("loading"):(_vm.stopwatch)?_vm._t("stopwatch",function(){return [_c('span',[_vm._v(" "+_vm._s(_vm.stopwatch))])]},null,{ stopwatch: _vm.stopwatch }):_vm._t("visits",function(){return [_c('span',[_vm._v(_vm._s(_vm.daysActive)+" Visits")])]},null,{daysActive: _vm.daysActive})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }